// extracted by mini-css-extract-plugin
module.exports = {"switchComponent":"Timetable_switchComponent__3fmHN","greeting":"Timetable_greeting__KDzcM","topButton":"Timetable_topButton__2C9lR","bestTime":"Timetable_bestTime__5f9XA"};